import {useCallback} from 'react';

import {SelectionApp} from '@web-catalog/types';

import {useGetVkId} from '@web-catalog/store/auth';

import {
  emitEcommerceEvent,
  emitYmEvent,
  logTmrEvent,
} from '@web-catalog/utils/analytics';

export const getFeaturingAnalyticsType = (
  type?: string,
  displayType?: 'GRID' | 'RAIL' | 'LIST',
) => {
  if (displayType) {
    switch (displayType) {
      case 'RAIL':
        return 'rail';
      case 'GRID':
        return 'grid';
      case 'LIST':
        return 'array';
    }
  }
  switch (type) {
    case 'WITH_COVER_APP':
      return 'mono';
    case 'WITH_COVER':
      return 'card';
    default:
      return undefined;
  }
};

export const useFeaturingAnalytics = () => {
  const getVkId = useGetVkId();

  const logPageView = useCallback(
    (
      featuring_id: string,
      featuring_name?: string,
      type?: string,
      displayType?: 'GRID' | 'RAIL' | 'LIST',
    ) => {
      const featuringType = getFeaturingAnalyticsType(type, displayType);

      logTmrEvent({
        logEvent: 'compilation.view',
        params: {
          compilation_id: featuring_id,
          compilation_name: featuring_name,
          compilation_type: featuringType,
          vk_id: getVkId(),
        },
      });
    },
    [getVkId],
  );

  const logAppSelect = useCallback(
    (
      app: SelectionApp,
      app_num: number,
      featuring_id: string,
      featuring_name?: string,
      compilation_type?: string,
    ) => {
      logTmrEvent({
        logEvent: 'app.select',
        params: {
          pageURL: 'compilation',
          compilation_framework_type: 'compilation',
          started_isStub: 0,
          app_packageName: app.packageName,
          app_num,
          compilation_id: featuring_id,
          compilation_name: featuring_name,
          compilation_type,
          vk_id: getVkId(),
        },
      });

      emitYmEvent({eventName: 'ecommerce_select_item'});
      emitEcommerceEvent({
        eventName: 'select_item',
        app: {
          packageName: app.packageName,
          appId: app.appId,
          type: app.appType,
          price: app.price ?? 0,
        },
        placement: {
          listName: featuring_name || 'Подборка',
          position: app_num,
        },
      });
    },
    [getVkId],
  );

  const logCompilationShow = useCallback(
    (featuring_id: string, featuring_name?: string, featuringType?: string) => {
      logTmrEvent({
        logEvent: 'compilation.show',
        params: {
          pageURL: 'compilation',
          compilation_framework_type: 'compilation',
          started_isStub: 0,
          compilation_id: featuring_id,
          compilation_name: featuring_name,
          compilation_type: featuringType,
          vk_id: getVkId(),
        },
      });
    },
    [getVkId],
  );

  return {
    logPageView,
    logAppSelect,
    logCompilationShow,
  };
};
